<app-array-input
  [name]="name"
  [formArray]="_formArray"
  [controlData]="_controlData"
></app-array-input>
